'use client'

import {cn} from '../../../lib/utils'

export type PublicScheduleDay = {
    key: string
}

export function PublicScheduleDayPicker({
    className,
    days,
    formatDayMonth,
    formatDayNumber,
    formatFullWeekday,
    formatMobileWeekday,
    isDayDisabled,
    onSelectDay,
    selectedDateKey,
    todayKey,
}: {
    className?: string
    days: PublicScheduleDay[]
    formatDayMonth: (dateKey: string) => string
    formatDayNumber: (dateKey: string) => string
    formatFullWeekday: (dateKey: string) => string
    formatMobileWeekday: (dateKey: string) => string
    isDayDisabled?: (day: PublicScheduleDay) => boolean
    onSelectDay: (dayKey: string) => void
    selectedDateKey: string | null
    todayKey: string
}) {
    const mobileDayGridStyle = {
        gridTemplateColumns: `repeat(${Math.max(days.length, 1)}, minmax(0, 1fr))`,
    }

    return (
        <div className={cn('mt-4 grid gap-1', className)} style={mobileDayGridStyle}>
            {days.map((day) => {
                const selected = day.key === selectedDateKey
                const isToday = day.key === todayKey
                const disabled = isDayDisabled?.(day) ?? false
                return (
                    <button
                        key={day.key}
                        type="button"
                        aria-label={`${formatFullWeekday(day.key)} ${formatDayMonth(day.key)}`}
                        aria-pressed={selected}
                        data-today={isToday ? 'true' : undefined}
                        disabled={disabled}
                        className={
                            selected
                                ? 'flex min-h-[56px] flex-col items-center justify-center rounded-[10px] border border-transparent bg-[linear-gradient(16deg,var(--landing-primary-600)_0%,var(--landing-secondary-500)_100%)] px-0.5 text-center text-white'
                                : disabled
                                    ? 'flex min-h-[56px] cursor-not-allowed flex-col items-center justify-center rounded-[10px] border border-transparent bg-[var(--landing-neutral-50)] px-0.5 text-center text-[var(--landing-neutral-300)] opacity-70'
                                    : 'flex min-h-[56px] flex-col items-center justify-center rounded-[10px] border border-[var(--landing-neutral-100)] bg-white px-0.5 text-center text-[var(--landing-neutral-600)] transition-colors hover:border-[var(--landing-primary-200)] hover:text-[var(--landing-primary-600)]'
                        }
                        onClick={() => {
                            if (!disabled) {
                                onSelectDay(day.key)
                            }
                        }}
                    >
                        <span className="text-[11px] font-semibold leading-none">{formatMobileWeekday(day.key)}</span>
                        <span className="mt-1 text-[16px] font-normal leading-none">{formatDayNumber(day.key)}</span>
                    </button>
                )
            })}
        </div>
    )
}
